import {
  ProjectsAssignedToProjectWorkersDocument,
  ProjectsAssignedToProjectWorkersFragment,
} from 'generated/resources/graphql'

import { useUnsafeMemo } from 'modules/core/hooks/useMemo'
import { useQuery } from 'modules/core/hooks/useQuery'

export type ProjectWorkers = ProjectsAssignedToProjectWorkersFragment[]

interface IUseGetProjectsAssignedToWorker {
  employeeIds: string[]
  onlyActiveProjects?: boolean
  currentlyAssigned?: boolean
  includeSubprojects?: boolean
}
export interface IProjectWorkers {
  loading: boolean
  projectsAssigned: ProjectWorkers | undefined
  hasProjectsToTrack: boolean
}

export const useGetProjectsAssignedToWorker = ({
  employeeIds,
  onlyActiveProjects = true,
  currentlyAssigned = true,
  includeSubprojects = false,
}: IUseGetProjectsAssignedToWorker): IProjectWorkers => {
  const { loading, data } = useQuery(ProjectsAssignedToProjectWorkersDocument, {
    variables: {
      employeeIds,
      onlyActiveProjects,
      assigned: currentlyAssigned,
      includeSubprojects: includeSubprojects,
    },
  })

  const hasProjectsToTrack = useUnsafeMemo(() => {
    if (!data) return false
    return data.projectManagement.projectWorkers.length > 0
  }, [data])

  return {
    loading,
    projectsAssigned: data ? data.projectManagement.projectWorkers : [],
    hasProjectsToTrack,
  }
}
